import React, { useState } from "react";
import { Table, Alert } from "antd";
import LocationMapModal from "../../../../components/LocationMap";

const EmployeeLocationTable = ({ locations }) => {

  const [show, setShow] = useState(false);
  const [coordinates, setCoordinates] = useState({
    latitude: '',
    longitude: '',
    time: ''
  });

  const showMap = (data) => {
    setCoordinates({
      latitude: data.latitude,
      longitude: data.longitude,
      time: new Date(data.timestamp * 1000).toLocaleString()
    });
    setShow(true);
  }

  const columns = [
    {
      title: "Latitude",
      dataIndex: "latitude",
      key: "latitude",
      render: (text, record) => <span className="table-avatar" style={{ cursor: 'pointer' }} onClick={() => showMap(record)}>{text}</span>
    },
    {
      title: "Longitude",
      dataIndex: "longitude",
      key: "longitude",
      render: (text, record) => <span className="table-avatar" style={{ cursor: 'pointer' }} onClick={() => showMap(record)}>{text}</span>
    },
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      key: "timestamp",
      render: (text, record) => <span className="table-avatar" style={{ cursor: 'pointer' }} onClick={() => showMap(record)}>{new Date(text * 1000).toLocaleString()}</span>
    },
    {
      title: "Location Name",
      dataIndex: "location_name",
      key: "location_name",
      render: (text, record) => <span className="table-avatar" style={{ cursor: 'pointer' }} onClick={() => showMap(record)}>{text || "N/A"}</span>
    },
  ];

  return locations.length > 0 ? (
    <>
      {show && <LocationMapModal coordinates={coordinates} setShow={setShow} />}
      <Table
        columns={columns}
        dataSource={locations}
        rowKey="id"
        pagination={{ pageSize: 5 }}
      />
    </>
  ) : (
    <Alert
      message="No location data available for the selected date"
      type="warning"
      showIcon
    />
  );
};

export default EmployeeLocationTable;
